import { EstimationData } from '../types/estimation';

export interface QuickEstimateResult {
  min: number;
  max: number;
}

const BASE_PRICES = {
  apartment: 400,
  house: 450,
  building: 350
} as const;

const RENOVATION_COEFFICIENTS = {
  light: 0.8,
  medium: 1,
  heavy: 1.2
} as const;

export const calculateQuickEstimate = (data: EstimationData): QuickEstimateResult => {
  // Vérification stricte des données requises
  if (!data?.propertyType || !Object.keys(BASE_PRICES).includes(data.propertyType)) {
    throw new Error('Type de bien invalide ou manquant');
  }
  if (!data?.area || data.area <= 0) {
    throw new Error('Surface invalide ou manquante');
  }
  if (!data?.renovationLevel || !Object.keys(RENOVATION_COEFFICIENTS).includes(data.renovationLevel)) {
    throw new Error('Niveau de rénovation invalide ou manquant');
  }

  // Prix de base selon le type de bien
  const basePrice = BASE_PRICES[data.propertyType] * data.area;

  // Application du coefficient de rénovation
  const renovationCoefficient = RENOVATION_COEFFICIENTS[data.renovationLevel];
  let totalPrice = basePrice * renovationCoefficient;

  // Ajout des coûts spécifiques si sélectionnés
  if (data.keyElements?.windows) {
    totalPrice += data.area * 150; // 150€/m² pour les fenêtres
  }
  if (data.keyElements?.kitchen) {
    totalPrice += 4500; // Forfait cuisine
  }
  if (data.keyElements?.bathroom) {
    totalPrice += 8000; // Forfait salle de bain
  }

  // Calcul de la marge de 10%
  const margin = totalPrice * 0.1;
  
  return {
    min: Math.round(totalPrice - margin),
    max: Math.round(totalPrice + margin)
  };
};